export default __webpack_public_path__ + "static/media/7-11-logo.75e31c93.png";